import { ArrowUpRightIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { applyToAll } from "src/services/client";
import Button from "../Inputs/Button";
import { Tooltip } from "flowbite-react";

const ApplyToCurrent = ({
  name,
  value,
  content = <ArrowUpRightIcon className="h-5" />,
  tooltip = "",
}: any) => {
  const updateSetting = async () => {
    await applyToAll(name, value);
    setUpdateTimer(true);
    setTimeout(() => {
      setUpdateTimer(false);
    }, 2000);
  };

  const [updating, setUpdateTimer] = useState(false);

  return (
    <div className={`flex ${"gap-3"} items-center`}>
      <Tooltip content={tooltip}>
        <div>
          <Button type="primary" onClick={updateSetting}>
            {content}
          </Button>
        </div>
      </Tooltip>
      <div
        className={`mt-2 text-sm  text-center text-main-orange transition ease-in-out ${updating ? "opacity-100" : "opacity-0"}`}
      >
        Clients updated!
      </div>
    </div>
  );
};

export default ApplyToCurrent;
